<template>
    <!-- 二维码 -->
    <div class="phone-scan">
        <div class="qr-image" id="browseInPhone">
            <div class="sohu-logo"></div>
        </div>
        <div class="text1">
            <span>扫码打开</span>
            <span class="border-font">手机搜狐网</span>
        </div>
        <div class="text2">
            <div>无需下载APP</div>
            <div>精彩内容随时看</div>
        </div>
    </div>
</template>
<script>
import { env } from '@/env'
import { addQueryArgs } from '@/utils/url-utils'
import QRCode from 'qrcodejs2'

export default {
    components: {
    },
    data() {
        return {

        }
    },
    mounted() {
        this.initQRCode()
    },
    methods: {
        // 初始化二维码
        initQRCode(){
            const anchorDom = document.getElementById("browseInPhone")
            const pathname = window.location.pathname
            const wapHostMap = {
                test: 'https://d2.m.sohu.com',
                pre: 'https://t3.m.sohu.com',
                prod: 'https://m.sohu.com',
            }
            const origin = wapHostMap[env] || wapHostMap.prod
            const url = origin + pathname
            const data = addQueryArgs(url, {
                "_trans_": "060005_pcsywzyewmdl"
            })
            new QRCode(anchorDom, {
                text: data,
                width: 80,
                height: 80,
                colorDark: '#000000',
                colorLight: '#ffffff',
                correctLevel: QRCode.CorrectLevel.H,
            })
        },

    }
}
</script>
<style lang="less" scoped>
    .phone-scan{
        margin-top: 24px;
        overflow: hidden;
        width: 108px;
        display: flex;
        flex-direction: column;
        align-items: center;
        flex-wrap: wrap;
        .qr-image{
            width: 88px;
            height: 88px;
            position: relative;
            background-color: #FFFFFF;
            display: flex;
            align-items: center;
            justify-content: center;
            .sohu-logo{
                width: 20px;
                height: 20px;
                background-color: #FFD100;
                border-radius: 3px;
                background-image: url('../../images/icon_logo.png');
                background-repeat: no-repeat;
                background-position: center;
                background-size: 14px 14px;
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate3d(-50%,-50%,0);
            }
            }
            .main-title{
                font-size: 0px;
            }
            .text1{
                margin-top: 4px;
                height: 17px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 12px;
                color: #111111;
                line-height: 17px;
                text-align: justify;
                font-style: normal;
                display: inline-flex;
            }
            .border-font{
                font-weight: 600;
            }
            .text2{
                margin-top: 4px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 12px;
                color: #999999;
                line-height: 14px;
                text-align: center;
                font-style: normal;
                display: block;
            }
        }
</style>